/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import * as MobileDetect from "react-device-detect";
import { partnerInfo } from "~/configs/partnerDetails";
import { get, find } from "lodash";
import { Redirect } from "react-router-dom";

const info = get(partnerInfo, "info");
const iosUrl = find(info, { key: "ios" });
const androidUrl = find(info, { key: "android" });

const Download = () => {
  let url = "/";
  if (MobileDetect.isIOS) {
    url = iosUrl.value;
  } else if (MobileDetect.isAndroid) {
    url = androidUrl.value;
  } else {
    url = "/";
  }

  useEffect(() => {
    window.location.href = url;
  }, [url]);

  return <div>"</div>;
};

export default Download;
